import { render } from "./AddGroup.vue?vue&type=template&id=6b14c38e&scoped=true"
import script from "./AddGroup.vue?vue&type=script&lang=js"
export * from "./AddGroup.vue?vue&type=script&lang=js"

import "./AddGroup.vue?vue&type=style&index=0&id=6b14c38e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b14c38e"]])

export default __exports__